import { RouteConfig } from "vue-router";

export const buildings: RouteConfig[] = [
  {
    // 建物管理
    path: "buildings/:groupId",
    component: () => import("@/pages/Buildings/_Tab.vue"),
    children: [
      {
        path: "",
        name: "buildings-list",
        component: () => import("@/pages/Buildings/BuildingsList.vue")
      },
      {
        path: "new",
        name: "building-new",
        component: () => import("@/pages/Buildings/BuildingsNew.vue")
      }
    ]
  },
  {
    // 建物詳細
    path: "buildings/:groupId/:buildingId",
    component: () => import("@/pages/Building/_Tab.vue"),
    children: [
      {
        path: "",
        name: "building-details",
        component: () => import("@/pages/Building/BuildingDetails.vue")
      },
      {
        path: "app",
        component: () => import("@/pages/Building/BuildingAppRelation.vue"),
        children: [
          {
            path: "",
            name: "building-app-relation"
          },
          {
            path: ":appUserId",
            name: "building-app-relation-select",
            component: () =>
              import("@/pages/Building/BuildingAppRelationSelect.vue")
          }
        ]
      },
      {
        path: "edit",
        name: "building-edit",
        component: () => import("@/pages/Building/BuildingEdit.vue")
      },
      {
        path: "log",
        name: "building-log",
        component: () => import("@/pages/Building/AuditLog.vue")
      }
    ]
  },
  {
    // 部屋詳細
    path: "buildings/:groupId/:buildingId/room/:roomGroupId/:roomId",
    component: () => import("@/pages/Room/_Tab.vue"),
    children: [
      {
        path: "",
        name: "room-details",
        component: () => import("@/pages/Room/RoomDetails.vue")
      },
      {
        path: "key",
        name: "room-key",
        component: () => import("@/pages/Room/KeyList.vue")
      },
      {
        path: "status",
        name: "room-status",
        component: () => import("@/pages/Room/ChangeStatus.vue")
      },
      {
        path: "remote",
        name: "room-remote",
        component: () => import("@/pages/Room/RemoteOperation.vue"),
        children: [
          {
            path: "open",
            name: "room-remote-open",
            component: () => import("@/pages/Room/RemoteOperationOpen.vue")
          },
          {
            path: "close",
            name: "room-remote-close",
            component: () => import("@/pages/Room/RemoteOperationClose.vue")
          }
        ]
      },
      {
        path: "log",
        name: "room-log",
        component: () => import("@/pages/Room/AuditLog.vue")
      },
      {
        path: "edit",
        name: "room-edit",
        component: () => import("@/pages/Room/RoomEdit.vue")
      }
    ]
  },
  {
    // 検索画面
    path: "search/:groupId",
    name: "search",
    component: () => import("@/pages/Search/Home.vue")
  },
  {
    // 検索結果 建物一覧
    path: "search-result/:groupId",
    name: "search-result",
    component: () => import("@/pages/Search/Result.vue")
  }
];
